<script>
import router from "@/router";
import push from "@/components/Menu/push.vue";
import http from "@/plugins/axios";

export default {
  name: 'search-icon',
  data: () => ({
    searchdialog : false,
    search : {
      data : []
    },
    value_search : "",
  }),
  computed: {
    push() {
      return push
    }
  },
  methods:{
    showproduct(id){
      router.push("/product/"+id)
    },
    getsearch(){
      if(this.value_search.length>=2){
        const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
        http.get("/products/search/"+this.value_search, { headers: { Authorization: AuthStr } })
            .then(response => {
              this.search = response.data;
            })
            .catch((error) => {
            });
      }
    },
    showSearch(){
      this.searchdialog = true;
    },
    showmenu(){
      $("#menu").fadeIn();
    },
    closemenu(){
      $("#menu").fadeOut();
    }
  },
  props: [
    "revese",
  ],
}
</script>

<template>
  <v-dialog
      v-model="searchdialog"
      max-width="400"
      persistent
  >
    <v-card
        prepend-icon="mdi-search-web"
        title="جستجوی محصول"
        style="direction: rtl"
    >
      <div class="col-12 float-right" style="padding: 0 20px">
        <div class="form-group" style="text-align: center">
          <input type="text" class="form-control" style="text-align: center" @keyup="getsearch" v-model="value_search"  placeholder="نام محصول یا کد را وارد کنید"/>
        </div>
      </div>
      <div v-if="search.data.length > 0" class="col-12 float-right" style="padding: 10px 20px;max-height: 150px;overflow-y: auto;font-size: 12pt !important;color: #1fa29d">
        <template v-for="(searchi, index)  in search.data" :key="index">
          <div class="col-12">
            <h6 @click="showproduct(searchi.id)">طرح {{searchi.cat_title}} - کد کالا {{searchi.title}}</h6>
          </div>
        </template>
      </div>
      <hr/>
      <div class="clearfix"></div>
      <template v-slot:actions>
        <v-spacer></v-spacer>

        <v-btn @click="searchdialog = false">
          بستن
        </v-btn>
      </template>
    </v-card>
  </v-dialog>

  <div class="col-2 float-left search" @click="showSearch">
    <i  class="fa-regular fa-search " ></i>
    <div style="/* display: inline-block; */color: rgb(31, 162, 157);font-size: 0.65rem;padding-right: 3px;margin-top: -6px;">جستجو</div>
  </div>
</template>

<style scoped>
.search{
  text-align: center;
  //margin-top: 5px;
}
.search i{
  font-size: 9pt !important;
  color: #1fa29d;
  margin-right: 7px;
}
a{
  color: #1fa29d;
  text-decoration: none;
}
a:hover{
  color: #005956;
}
</style>